<template>
  <div class="qrcode">
    <qrcode :value="value" :size="size" level="H"></qrcode>
    <img v-if="!noLogo" :src="logoPng" class="qrcode-logo" />
  </div>
</template>

<script>
import Qrcode from 'qrcode.vue';
import logoPng from '@/assets/image/ic-logo.png';

export default {
  props: {
    value: String,
    size: { type: Number, default: 130 },
    noLogo: Boolean,
  },
  components: {
    Qrcode,
  },

  data() {
    return {
      logoPng,
    };
  },
};
</script>

<style lang="scss" scoped>
.qrcode {
  position: relative;

  &-logo {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>